import RequestType from './RequestType'
import EquipmentClass from './EquipmentClass'
import EquipmentActivity from './EquipmentActivity'
export class ActivityReason {
    ID?: number;
    RequestTypeID?: number;
    RequestType?: RequestType;
    EquipmentClassID?: number;
    EquipmentClass?: EquipmentClass;
    EquipmentActivityID?: number;
    EquipmentActivity?: EquipmentActivity;
    Code?: string;
    Name?: string;
    FullName?: string;
    Inactive?: boolean;
}

export default ActivityReason;